import Project from '../atom/project';
import Widget from '../atom/widget';
import React from 'react';
class Projects extends React.Component {
    static indexProduct = 0;
    constructor(props) {
        super(props);
        this.state = {
            products: []
        };
    }
    localData() {
        let products = sessionStorage.getItem('products');
        if (products === null)
            products = '[]';
        return JSON.parse(products);
    }
    render() {
        let JSONProducts = this.localData();
        if (JSONProducts.length < this.state.products.length)
            JSONProducts = this.state.products;
        const widgets = [];
        for (const product of JSONProducts)
            widgets.push(React.createElement(Project, { key: `product-${Projects.indexProduct++}`, name: product.name, link: product.link, imageUrl: product.imageUrl, description: product.description }));
        return (React.createElement(React.Fragment, null,
            React.createElement(Widget, null, widgets)));
    }
    async componentDidMount() {
        if (this.state.products.length === 0 || sessionStorage.getItem('products') === null) {
            const products = await fetch('/portfolio/assets/products.json').then(res => res.json());
            this.setState({ products });
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        sessionStorage.setItem('products', JSON.stringify(this.state.products));
    }
}
export default Projects;
